import React, { FunctionComponent, ReactElement } from 'react'
import { navigate, RouteComponentProps } from '@reach/router'

import { useStoreState } from '../store/store.hooks'
import { CircularProgress } from '@material-ui/core'
import { useRouteLogger } from './useRouteLogger'

type Props = RouteComponentProps & {
  children: any
}

export const ProfessionalRoot: FunctionComponent<Props> = ({ children }) => {
  const { profileContents } = useStoreState((store) => store.profile)
  useRouteLogger()
  if (!profileContents.userTypeId) {
    return <CircularProgress color="inherit" />
  }
  // Handle if a patient wants to enter professional routes
  if (
    typeof profileContents.userTypeId === 'number' &&
    profileContents.userTypeId !== 1
  ) {
    navigate('/')
  }
  // Just in case some1 logs in with an admin
  // else {
  //   alert('Invalid userTypeId')
  //   return null
  // }
  // https://stackoverflow.com/a/54908762/3155277
  return children as ReactElement<any>
}
